var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "wxEditor" } }, [
    _c(
      "div",
      {
        directives: [
          {
            name: "loading",
            rawName: "v-loading",
            value: _vm.quillUpdateImg,
            expression: "quillUpdateImg",
          },
        ],
        attrs: { "element-loading-text": "请稍等，图片上传中" },
      },
      [
        _c("el-upload", {
          staticClass: "avatar-uploader",
          attrs: {
            action: _vm.serverUrl,
            name: "file",
            headers: _vm.header,
            "show-file-list": false,
            data: _vm.uploadData,
            "on-success": _vm.uploadSuccess,
            "on-error": _vm.uploadError,
            "before-upload": _vm.beforeUpload,
          },
        }),
        _c("quill-editor", {
          ref: "myQuillEditor",
          staticClass: "editor",
          attrs: { options: _vm.editorOption },
          on: {
            blur: function ($event) {
              return _vm.onEditorBlur($event)
            },
            focus: function ($event) {
              return _vm.onEditorFocus($event)
            },
            change: function ($event) {
              return _vm.onEditorChange($event)
            },
          },
          model: {
            value: _vm.content,
            callback: function ($$v) {
              _vm.content = $$v
            },
            expression: "content",
          },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }